module.exports = __webpack_public_path__ + "static/img/Group12@2x.9f26de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group12@2x.png
// module id = cskI
// module chunks = 6